import React from "react";
import { FieldSet } from "src/components/event_transaction/components/shared/Form/FieldSet";

const MainInformation = (props) => {
  const { control, disabled, required } = props;

  return (
    <div>
      <div className="flex flex-col gap-2">
        <div className="grid grid-cols-6 gap-3">
          {/* company logo */}
          <div className="col-span-2 w-full h-[15rem]">
            <FieldSet
              disabled={disabled}
              name="companyImage"
              type="file"
              control={control}
              label={"Company logo"}
              fullWidth
            />
          </div>

          <div className="col-span-4 grid grid-cols-2 gap-2">
            {/* company information */}
            <div>
              <FieldSet
                disabled={disabled}
                required={required}
                name="taxId"
                type="text"
                control={control}
                label={"Tax ID"}
                placeholder={!disabled ? "Please enter tax ID" : ""}
              />
            </div>

            <div>
              <FieldSet
                disabled={disabled}
                required={required}
                name="companyName"
                type="text"
                control={control}
                label={"Company name"}
                placeholder={!disabled ? "Please enter company name" : ""}
              />
            </div>

            <div>
              <FieldSet
                disabled={disabled}
                required={required}
                name="companyAddress"
                type="text"
                control={control}
                label={"Company address"}
                placeholder={!disabled ? "Please enter company address" : ""}
              />
            </div>

            <div>
              <FieldSet
                disabled={disabled}
                required={required}
                name="incorporationDate"
                type="datepicker"
                control={control}
                label={"Incorporation Date"}
              />
            </div>

            <div>
              <FieldSet
                disabled={disabled}
                name="numberOfEmployees"
                type="textNumeric"
                control={control}
                label={"Number of employees"}
                placeholder={
                  !disabled ? "Please enter number of employees" : ""
                }
                thousandSeparator
              />
            </div>

            <div>
              <FieldSet
                disabled={disabled}
                name="workingDays"
                type="textNumeric"
                control={control}
                label={
                  "Working days (excluding public holidays and company holidays)"
                }
                placeholder={!disabled ? "Please enter working days" : ""}
                thousandSeparator
              />
            </div>

            <div>
              <FieldSet
                disabled={disabled}
                name="grossSalary"
                type="textNumeric"
                control={control}
                label={"Gross salary"}
                placeholder={!disabled ? "Please enter gross salary" : ""}
                thousandSeparator
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="col-span-4"></div>
        <div></div>
      </div>
    </div>
  );
};

export default MainInformation;
